import { uid, formatError } from 'utils';

export const InputProto = {
  name: 'InputProto',

  computed: {
    labelId () { return `${ this.uid }-${ this.name || '$unnamed' }` },
  },

  data () { return { uid: uid() } },

  methods: {
    $emitToField (value = this.value, eventName = 'input') {
      const { name } = this;
      const event = value?.hasOwnProperty('target') && value;
      const toEvent = !this.valueModifiers?.input && !!name;
      if (event && !toEvent)
        value = event.target.value;

      // console.log(`${ this.$options.name || 'This' }.$emitToField`, value);
      this.$emit(
        eventName,
        toEvent ?
            (event || { target: { name, value } })
          : value
      );

      if (!toEvent && eventName === 'input')
        this.$emit('update:value', value);

      return this;
    },

    $bindModel (propName = 'value') {
      return {
        name: this.name,
        value: this[propName],
        onInput: this.$emitToField,
      };
    },

    $reemit (...events) {
      let reemit = {};
      for (let i = 0; i < events.length; i++ ) {
        const name = `on${ events[i][0].toUpperCase() }${ events[i].substr(1) }`;
        reemit[name] = (...args) => this.$emit(events[i], ...args);
      }
      return reemit;
    },

    $onInput (payload) { this.$emitToField(payload) },

    formatError,
  },

  emits: ['input', 'blur', 'focus', 'click', 'keydown', 'update:value', 'erase'],
  // emits: ['update:value'],
  props: {
    label: String,
    name: String,
    // name: { type: String, required: true }, // uncomment to check where there are no name attr
    value: String,
    valueModifiers: Object,
    disabled: Boolean,
    required: Boolean,
    error: [Object, String, Boolean, Error],

    dirty: Boolean,
    touched: { type: Boolean, default: false },
    fielded: { type: Boolean },
  },
};

export default InputProto;